import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}
import { LanguageProvider } from '@/context/LanguageContext';
import { InquiryListProvider } from '@/context/InquiryListContext';
import { Layout } from '@/components/Layout';
import HomePage from '@/pages/HomePage';
import CatalogPage from '@/pages/CatalogPage';
import ProductDetailPage from '@/pages/ProductDetailPage';
import CraftPage from '@/pages/CraftPage';
import ContactPage from '@/pages/ContactPage';
import ImpressumPage from '@/pages/ImpressumPage';
import PrivacyPage from '@/pages/PrivacyPage';
import NotFoundPage from '@/pages/NotFoundPage';
import '@/App.css';

function App() {
  return (
    <LanguageProvider>
      <InquiryListProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              {/* Main Pages */}
              <Route path="/" element={<HomePage />} />
              <Route path="/catalog" element={<CatalogPage />} />
              <Route path="/product/:slug" element={<ProductDetailPage />} />
              <Route path="/craft" element={<CraftPage />} />
              <Route path="/contact" element={<ContactPage />} />
              
              {/* Legal Pages */}
              <Route path="/legal/impressum" element={<ImpressumPage />} />
              <Route path="/legal/privacy" element={<PrivacyPage />} />
              
              {/* 404 */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </InquiryListProvider>
    </LanguageProvider>
  );
}

export default App;
